export enum ReportType {
    DAYWISE = 'DAYWISE',
    WEEKWISE = 'WEEKWISE',
    QUARTERWISE = 'QUARTERWISE'
  }
